import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, Optional } from '@angular/core';
import { LoadingSpinnerComponent } from '../../../forms/loading-spinner/loading-spinner.component';

export type LoadingDialogData = {
  message?: string;
} & Record<string, unknown>;

@Component({
  selector: 'app-loading-dialog',
  standalone: true,
  imports: [LoadingSpinnerComponent],
  templateUrl: './loading-dialog.component.html',
  styleUrl: './loading-dialog.component.scss',
})
export class LoadingDialogComponent {
  constructor(
    @Optional() @Inject(DIALOG_DATA) public data: LoadingDialogData | null,
    public dialogRef: DialogRef<void>
  ) {}
}
